<template>
  <div id="dashboard" v-if="isDashboardLoaded">
    <!--begin::Row-->
    <b-row class="mt-0 mt-lg-3">
      <b-col xl="9">
        <avg-max-risk
          :score="score"
          :evolution="scoreEvolution.series"
          :discrete="scoreEvolution.discrete"
        />
      </b-col>
      <b-col xl="3">
        <slide-status-card :modules="modules" />
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="3" md="6" v-if="hasModule(['risk'])">
        <control
          :title="$t('messages.dashboard.modules.risk.title')"
          :evolution="riskEvolution.series"
          :discrete="riskEvolution.discrete"
          :base="10"
        />
      </b-col>
      <b-col xl="3" md="6" v-if="hasModule(['awareness'])">
        <control
          :title="$t('messages.dashboard.cybersecurity.status')"
          :evolution="cybersecurityEvolution.series"
          :discrete="cybersecurityEvolution.discrete"
          :base="10"
        />
      </b-col>
      <b-col xl="3" md="6" v-if="hasModule(['wellbeing'])">
        <control
          :title="$t('messages.dashboard.modules.wellbeing.title')"
          :evolution="wellbeingEvolution.series"
          :discrete="wellbeingEvolution.discrete"
          :base="10"
        />
      </b-col>
      <b-col xl="3" md="6">
        <control
          :title="$t('messages.dashboard.modules.progress.title')"
          :value="progress"
          :base="10"
          :evolution="progressEvolution.series"
          :discrete="progressEvolution.discrete"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" class="mb-3" v-if="hasModule(['awareness'])">
        <cyber-chart :cybersecurity="cybersecurity" />
      </b-col>
      <b-col md="6" class="mb-3" v-if="hasModule(['awareness'])">
        <cyber-list :dimensions="cybersecurity.data" />
      </b-col>
    </b-row>
    <!--end::Row-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AvgMaxRisk from "@/components/dashboard/AvgMaxRisk.component";
import CyberChart from "@/components/dashboard/CyberChart.component";
import SlideStatusCard from "@/components/dashboard/SlideStatusCard.component";
import Control from "@/components/dashboard/Control.component";
import CyberList from "@/components/dashboard/CyberList.component";

export default {
  name: "ControllerDashboard",
  components: {
    AvgMaxRisk,
    CyberChart,
    SlideStatusCard,
    Control,
    CyberList
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("Constants", ["isConstantsActive"]),
    ...mapGetters("Auth", ["hasModule"]),
    ...mapGetters("Company", [
      "isDashboardLoaded",
      "cybersecurity",
      "wellbeing",
      "score",
      "progress",
      "modules",
      "scoreEvolution",
      "riskEvolution",
      "wellbeingEvolution",
      "cybersecurityEvolution",
      "progressEvolution"
    ])
  },
  methods: {
    ...mapActions("Company", ["loadDashboard"]),
    ...mapActions("Auth", ["changeDefaultView"])
  },
  mounted() {
    if (this.isConstantsActive && !this.isDashboardLoaded) this.loadDashboard();
    this.changeDefaultView("ControllerDashboard");
  },
  watch: {
    isConstantsActive(value) {
      if (value === true) this.loadDashboard();
    },
    isDashboardLoaded(value) {
      if (this.isConstantsActive && value === false) this.loadDashboard();
    }
  }
};
</script>
